/* PLATNÉ DATUM NAROZENÍ — JEDNA DEFINICE pro bránu průvodce i engine plánu.
 * ============================================================================
 *
 * PROČ (nález R5, 14. 10. 2026): brána „Připraveno na plán?“ (minimumPlanu,
 * verohodnost) brala datum přísně — RRRR-MM-DD a skutečný den v kalendáři —,
 * kdežto engine (osobyZAnalyzy.partnerBezNarozeni) benevolentně přes
 * `new Date(...)`. U hodnot jako „1985“, „1985-03“, „1985-02-30“ nebo
 * „3/15/1985“ (import, stará data) brána tvrdila „bez data — pojištění
 * partnera nespočteme“ a chtěla důvod, ale plán partnera normálně pojistil.
 * Teď obě strany čtou tenhle modul.
 *
 * Bez importů — čtou ho lib/osobyZAnalyzy.js (engine) i
 * lib/analyzaV2/verohodnost.js (brána); verohodnost importuje osobyZAnalyzy,
 * takže opačný import by udělal kruh.
 */

const RX_DATUM = /^(\d{4})-(\d{2})-(\d{2})/;

/** Platné kalendářní datum → UTC ms půlnoci, jinak null (2026-02-31 není den). */
export function denNarozeni(v) {
  const m = RX_DATUM.exec(String(v ?? "").trim());
  if (!m) return null;
  const [, r, me, d] = m;
  const t = Date.UTC(+r, +me - 1, +d);
  const dt = new Date(t);
  if (dt.getUTCFullYear() !== +r || dt.getUTCMonth() !== +me - 1 || dt.getUTCDate() !== +d) return null;
  return t;
}

/** Dnešek jako UTC půlnoc — stejně jako rodina.js vek(). */
export function dnesUtc(dnes) {
  const ref = dnes instanceof Date && Number.isFinite(dnes.getTime()) ? dnes : new Date();
  return Date.parse(`${ref.toISOString().slice(0, 10)}T00:00:00Z`);
}

/** Platné datum narození dospělého: skutečný den, ne v budoucnu (k `dnes`). */
export function platneNarozeni(v, dnes) {
  const t = denNarozeni(v);
  return t != null && t <= dnesUtc(dnes);
}

/** Kotva v adrese analýzy: „skoč na datum narození partnera“ (tlačítko
 *  u hlášky „zajištění nespočteno“ v Návrhu → AnalyzaV2Page, nález D2). */
export const KOTVA_NAROZENI_PARTNERA = "narozeni-partner";
